<template>
  <FormGroup>
    <slot />
    <FormLabel />

    <div :id="toolbarId">
      <span class="ql-formats">
<!--        <select class="ql-font"></select>-->
        <!--        <select class="ql-size"></select>-->
        <select class="ql-header"></select>
      </span>
      <span class="ql-formats">
        <button class="ql-bold" title="bold"></button>
        <button class="ql-italic" title="italic"></button>
        <button class="ql-underline" title="underline"></button>
        <button class="ql-strike" title="strike"></button>
<!--        <button class="ql-link" title="add link"></button>-->
        <button v-if="canMention" class="ql-user-mention" title="add mention">
          <i class="bi bi-at"></i>
        </button>

        <select class="ql-color"></select>
      </span>
      <!--      <span class="ql-formats">-->
      <!--        <select class="ql-color"></select>-->
      <!--        <select class="ql-background"></select>-->
      <!--      </span>-->
      <!--      <span class="ql-formats">-->
      <!--        <button class="ql-script" value="sub"></button>-->
      <!--        <button class="ql-script" value="super"></button>-->
      <!--      </span>-->
      <!--      <span class="ql-formats">-->
      <!--        <button class="ql-header" value="1"></button>-->
      <!--        <button class="ql-header" value="2"></button>-->
      <!--        <button class="ql-blockquote"></button>-->
      <!--        <button class="ql-code-block"></button>-->
      <!--      </span>-->
      <span class="ql-formats">
        <button class="ql-list" value="ordered" title="ordered list"></button>
        <button class="ql-list" value="bullet" title="bullet list"></button>
        <select class="ql-align" title="align"></select>
        <button class="ql-indent" value="-1" title="reduce indent"></button>
        <button class="ql-indent" value="+1" title="indent"></button>
      </span>
      <!--      <span class="ql-formats">-->
      <!--        <button class="ql-direction" value="rtl"></button>-->
      <!--      </span>-->
      <!--      <span class="ql-formats">-->
      <!--        <button class="ql-link"></button>-->
      <!--        <button class="ql-image"></button>-->
      <!--        <button class="ql-video"></button>-->
      <!--        <button class="ql-formula"></button>-->
      <!--      </span>-->
      <span class="ql-formats">
        <button class="ql-clean" title="remove formatting"></button>
      </span>
    </div>

    <div class="editor-container" :class="wrapperClass">
      <div
        ref="editor"
        :id="editorId"
        :class="['bootstrap-editor text-small', elclass]"
      ></div>
    </div>

    <transition name="fade">

      <div v-if="showMentionList" class="ml-container" :style="mentionListStyles">
        <div class="ml-header">
          <div class="text">Mention User</div>
          <div class="close" @click="closeMentionList">
            <i class="bi bi-x"></i>
          </div>
        </div>

        <div class="list-group mention-list">
          <!-- Loading indicator -->
          <a v-if="userListIsLoading">
            <ComponentLoader :is-loading=userListIsLoading></ComponentLoader>
            Loading...
          </a>
          <!-- List item display -->
          <a
            v-for="(user, index) in filteredUsers"
            :key="user.id"
            @click="selectMention(user)"
            href="#" class="list-group-item list-group-item-action">
            {{ user.email }}
          </a>
          <!-- No results display -->
          <a v-if="!userListIsLoading && filteredUsers.length === 0">No results</a>
        </div>

      </div>
    </transition>

  </FormGroup>
</template>
<script>

import Quill from "quill"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import debounce from "lodash/debounce"
import Toolbar from "quill/modules/toolbar"
import ComponentLoader from "../../../loaders/ComponentLoader.vue"

import ImageResize from "quill-image-resize"
import MentionModule from "../../../../plugins/quill/MentionModule"
import ApiService from "../../../../services/ApiService"

export default {
  components: { ComponentLoader },
  // components: { VueEditor },
  props: {
    wrapperClass: {
      type: [String, Array, Object],
      default: () => []
    },
    editorId: {
      type: String,
      default: "editor"
    },
    toolbarId: {
      type: String,
      default: "toolbar-container"
    },
    modelValue: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    toolbar: {
      type: String,
      default: "minimal" // minimal, limited, full
    },
    editorToolbar: {
      type: Array,
      default: null
    },
    editorOptions: {
      type: Object,
      default: null
    },
    canMention: {
      type: [Boolean],
      default: false
    },
    // Imported from FormMixins.js
    label: {
      type: [String, Boolean],
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    elclass: {
      type: String,
      default: null
    },
    error: {
      type: String,
      default: null
    },
    help: {
      type: String,
      default: null
    },
    labelClass: {
      type: String,
      default: null
    },
    groupClass: {
      type: String,
      default: null
    },
    hideErrorText: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    pattern: {
      type: String,
      default: null
    },
    invalidMessage: {
      type: String,
      default: null
    },
    minlength: {
      type: Number,
      default: null
    },
    maxlength: {
      type: Number,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    tabindex: {
      type: Number,
      default: null
    },

  },
  emits: ["update:modelValue"],
  data() {
    return {
      isInternalUpdate: false,
      editor: null,
      userList: [],
      userListIsLoading: false,
      users: [],
      filteredUsers: [],
      showMentionList: false,
      mentionListStyles: { top: "55px", left: "50px" },
      selectedIndex: 0,
      searchTerm: "",
      custom: [
        ["undo"],
        ["bold", "italic", "underline", "strike"],
        ["link"],
        [{ list: "ordered" }, { list: "bullet" }, { align: [] }]
      ],
      minimal: [
        ["undo"],
        ["bold", "italic", "underline", "strike"],
        ["link"],
        [{ list: "ordered" }, { list: "bullet" }, { align: [] }]
      ],
      limited: [
        ["undo"],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["link", "blockquote"],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"]
      ],
      full: [
        ["undo", "redo"],
        [{ header: [] }, { size: [".5rem", ".75rem", false, "1.25rem", "1.5rem"] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["link", "blockquote", "image"],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"]
      ]
    }
  },

  computed: {
    // strippedContent() {
    //   return (this.localModel || '').replace(/(<([^>]+)>)/gi, '')
    // },
    // isRequired() {
    //   return this.required && !this.strippedContent.length ? true : null
    // },
    // quill() {
    //   return this.$refs.editor ? this.$refs.editor.quill : null
    // },
    // getEditorToolbar() {
    //   return this.editorToolbar ? this.editorToolbar : this[this.toolbar] ? this[this.toolbar] : this.minimal
    // },
    getEditorToolbar() {
      return this.custom
    },
    // Imported from FormMixins.js
    hasError() {
      return typeof this.error === "string" && !!this.error.length
    }

  },
  beforeMount() {

    const Embed = Quill.import("blots/embed")

    class MentionSpanBlot extends Embed {
      static create(value) {
        let node = super.create()
        // node.setAttribute('contenteditable', false);
        node.setAttribute("data-user-id", value.userId)
        node.innerText = value.text
        node.classList.add("mention-span")
        return node
      }

      html() {
        const { text, userId } = this.constructor.value(this.domNode)
        return `<span class="mention-span" data-user-id="${userId}">${text}</span>`
      }

      static value(node) {
        return {
          text: node.innerText,
          userId: node.getAttribute("data-user-id")
        }
      }

      static formats(node) {
        return node.getAttribute("data-user-id")
      }

      // format(name, value) {
      //   if (name === 'mention-span' && value) {
      //     this.domNode.setAttribute('data-user-id', value);
      //   } else {
      //     super.format(name, value);
      //   }
      // }
    }

    MentionSpanBlot.blotName = "mention-span" // name used in formats
    MentionSpanBlot.tagName = "span"         // element tag
    MentionSpanBlot.className = "mention-span"
    Quill.register(MentionSpanBlot)

  },
  mounted() {

    this.initQuill()

    // let container = Array.from(this.lodash.get(this.$refs, 'editor.$el.children', [])).find(
    //   (c) => c.id === 'quill-container'
    // )
    // let editor = Array.from(this.lodash.get(container, 'children', [])).find((c) => c.classList.contains('ql-editor'))
    // if (editor) {
    //   editor.dataset.name = this.name
    // }
  },
  methods: {

    initQuill() {

      var defaultPlaceholder = "Enter text here"
      var placeholder

      if (this.placeholder && this.placeholder.length > 1) {
        placeholder = this.placeholder
      } else {
        placeholder = defaultPlaceholder
      }

      this.quillEditor = new Quill(this.$refs.editor, {
        // debug: 'info',
        theme: "snow",
        placeholder: placeholder,
        readOnly: this.readonly,
        modules: {
          toolbar: {
            container: `#${this.toolbarId}`
          }
        }
      })

      // Register toolbar mention button
      if (this.canMention) {
        const toolbar = this.$el.querySelector(".ql-toolbar")
        if (toolbar) {
          const mentionButton = this.$el.querySelector(".ql-user-mention")
          mentionButton.addEventListener("click", () => {
            const cursorPos = this.quillEditor.getSelection(true).index
            this.quillEditor.insertText(cursorPos, "@")
            this.quillEditor.setSelection(cursorPos + 1)
          })
        }
      }

      this.editor = this.quillEditor

      if (this.modelValue && this.modelValue.length > 0) {
        const deltaOne = this.quillEditor.clipboard.convert({ html: this.modelValue })
        this.quillEditor.setContents(deltaOne, "silent")
      }

      this.editor.on("text-change", (delta) => {
        this.handleMention(delta)
        this.handleTextChange()
      })

    },

    handleMention(delta) {
      if (!this.canMention) return
      let selection = this.quillEditor.getSelection()
      if (!selection) return

      const textBeforeCursor = this.quillEditor.getText(0, selection.index)
      const mentionMatch = textBeforeCursor.match(/@([\w]*)$/)

      // Determine if last typed character was an @ symbol from quill's delta operations
      var deltaOps = this.lodash.get(delta, "ops", null)
      var shouldActivate = false
      // Iterate delta operations
      this.lodash.forEach(deltaOps, function(op) {
        if (op.insert == "@") {
          shouldActivate = true
        }
      })

      if (mentionMatch || shouldActivate) {
        // Retrieve search text
        if (mentionMatch) {
          var searchTerm = mentionMatch[1].toLowerCase()
        } else {
          var searchTerm = ""
        }
        // Retrieve list of users
        this.fetchUsers(searchTerm)
        this.filteredUsers = this.users.filter(user =>
          user.name.toLowerCase().includes(searchTerm)
        )

        if (this.filteredUsers.length > 0) {
          this.showMentionList = true
          this.selectedIndex = 0
          // Get the cursor position
          const bounds = this.quillEditor.getBounds(selection.index)
          this.mentionListStyles = {
            top: `${bounds.top + 55}px`,
            left: `${bounds.left + 50}px`
          }
        } else {
          this.showMentionList = false
        }
      } else {
        this.showMentionList = false
      }
    },

    fetchUsers: debounce(async function(searchTerm) {
      this.userListIsLoading = true
      this.showMentionList = true
      try {
        const response = await ApiService.get(`/users/search?search=${searchTerm}`, {})
        const data = response.data.data
        // Expected return is a json array with user data
        this.filteredUsers = data
      } catch (error) {
        console.error("Error fetching users:", error)
        this.filteredUsers = []
      } finally {
        this.userListIsLoading = false
      }
    }, 100),

    selectMention(user) {
      let selection = this.quillEditor.getSelection(true)
      if (!selection) return

      // Remove "@ + search term" and insert the formatted mention
      const textBeforeCursor = this.quillEditor.getText(0, selection.index)
      const mentionStartIndex = textBeforeCursor.lastIndexOf("@")
      const currentIndex = selection.index - mentionStartIndex
      this.quillEditor.deleteText(mentionStartIndex, currentIndex)

      // Insert mention with styling
      const mentionText = `@${user.first_name}-${user.last_name} `
      this.quillEditor.insertEmbed(mentionStartIndex, "mention-span", { text: mentionText, userId: user.id }, "api")

      // Set the user's cursor one space after the embedded blot
      this.quillEditor.setSelection(selection.index + 1, 0, "api")
      this.showMentionList = false
      this.quillEditor.update()
    },

    closeMentionList() {
      this.userListIsLoading = false
      this.showMentionList = false
    },

    handleTextChange() {
      //const content = this.quillEditor.root.innerHTML
      const content = this.quillEditor.getSemanticHTML()

      // Emit text update to parent object
      this.$emit("update:modelValue", content)
    },

    setHTML(html) {
      if (this.quillEditor) {
        const delta = this.quillEditor.clipboard.convert({ html: this.modelValue })
        this.quillEditor.setContents(delta, "silent")
      }
    },
  },
}
</script>
